/** Normalize GET_USER_DATA payload after /v2/user/me shape change. */
export function parseMeResponse(payload) {
  if (payload && typeof payload === 'object' && payload.user) {
    return {
      user: payload.user,
      tokenLastCompanyId: payload.lastCompany || null,
    };
  }
  return { user: payload, tokenLastCompanyId: null };
}
